export default __webpack_public_path__ + "static/media/hamburger.e2613ee7.svg";